<template>
    <div>
        <common-table
                :table-columns="tableColumns"
                :url="url" :operate="[]"
                :searchs="searchs"
                :form-fields="formFields"
                :permission="permission"/>
    </div>
</template>

<script>
    import CommonTable from "@/components/CommonTable/CommonTable";
    export default {
        name: "FacebookConfig",
        components: {CommonTable},
        data(){
            return {
                searchs: [{
                    name: 'agentId',
                    placeholder: '代理',
                    type: 'select',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                }],
                permission:{
                    add: 'facebookConfig:add',
                    update: 'facebookConfig:update',
                    delete: 'facebookConfig:delete',
                    deleteBatch: 'facebookConfig:deleteBatch'
                },
                url: {
                    get: '/facebookConfig/listByCondition',
                    add: '/facebookConfig/add',
                    update: '/facebookConfig/update',
                    delete: '/facebookConfig/delete/',
                    delete_batch: '/facebookConfig/deleteBatch',
                    status: '/facebookConfig/status',
                },
                tableColumns: [{
                    field: 'id',
                    label: 'Id',
                    show: true,
                    width: '100',
                }, {
                    field: 'agentId',
                    label: '代理',
                    selectUrl: '/agent/getAll',
                    selectData: [],
                    show: {
                        type: 'select'
                    },
                    width: '',
                }, {
                    field: 'eventId',
                    label: '事件ID',
                    show: true,
                    width: '',
                },{
                    field: 'createTime',
                    label: '时间',
                    show: true,
                    width: '',
                }],
                operate: [],
                formFields: {
                    addTitle: '添加',
                    updateTitle: '修改',
                    model: [{
                        field: 'agentId',
                        label: '代理',
                        type: 'select',
                        selectUrl: '/agent/getAll',
                        selectData: [],
                        placeholder: '请选择',
                        rules: [{
                            message: '请选择代理', trigger: 'blur', required: true
                        }],
                        add: true,
                        update: true,
                    }, {
                        field: 'eventId',
                        label: '事件ID',
                        type: 'input',
                        placeholder: '事件ID',
                        rules:[{message: '请输入事件ID', trigger: 'blur', required: true}],
                        add: true,
                        update: true,
                    }],
                }
            }
        }
    }
</script>

<style scoped>

</style>
